<template>
  <div v-if="similar_productsLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
  <div v-if="similar_productsError" class="mc-error">{{ productsError }}</div>
  <div class="cr-detail__section" v-if="similar_productsLoaded && similar_products.length > 0" >
    <div class="cr-detail__section-title">
      Похожие товары
    </div>
    <div class="cr-detail__section-body">
      <div class="cr-products-slider">
        <swiper
            wrapperTag="ul"
            :modules="modules"
            :scrollbar="{ draggable: true, el: '.swiper-scrollbar'+uniqueId}"
            :pagination="false"
            class="cr-products-slider__wrapper swiper"
            wrapperClass="cr-products-slider__list swiper-wrapper">
          <swiper-slide v-for="item in similar_products" class="cr-products-slider__item swiper-slide" tag="li">
            <product-item :product="item" />
          </swiper-slide>
          <template v-slot:container-end><div :class="'swiper-scrollbar swiper-scrollbar'+uniqueId"></div></template>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import { Pagination, Navigation, Scrollbar } from 'swiper';
import ProductItem from './ProductItem.vue'
export default {
  data: () => ({
    modules: [Pagination, Navigation, Scrollbar],
    uniqueId: 'slider'
  }),
  props: {
    id: ''
  },
  created() {
    this.fetchSimilarProducts(this.$props.id);
  },
  computed: {
    ...mapGetters('similarproducts', [
      'similar_products',
      'similar_productsLoading',
      'similar_productsError',
      'similar_productsLoaded'
    ]),
  },
  components: {
    Swiper,
    SwiperSlide,
    ProductItem
  },
  methods: {
    ...mapActions('similarproducts', [
      'fetchSimilarProducts'
    ]),
  },
}
</script>
